/**
 * __ShapeDiver 3D Viewer Application__, copyright (c) 2018 _ShapeDiver GmbH_
 *
 * *PluginConstants.js*
 *
 * ### Content
 *   * definition of constants used by the plugins, like
 *   * logging logging levels,
 *   * default settings, ...
 *
 * @module PluginConstants
 * @author Alex Schiftner <alex@shapediver.com>
 */


/**
 ShapeDiver 3D Viewer Application

 PluginConstants.js

 Content:
   Definition of constants used by the plugins
     - logging levels
     - default settings
     - ...

  Copyright (c) 2018 ShapeDiver GmbH

  @module PluginConstants
 */

/**
  Import globally defined logging constants
 */
var loggingConstants = require('../shared/constants/LoggingConstants');

/**
  Use globally defined logging levels
 */
var loggingLevels = loggingConstants.loggingLevels;

/**
  Import globally defined messaging constants
 */
var messagingConstants = require('../shared/constants/MessagingConstants');

/**
  Use globally defined messaging topics
 */
var messageTopics = messagingConstants.messageTopics;

/**
  Use globally defined messaging data types
 */
var messageDataTypes = messagingConstants.messageDataTypes;

/**
  Import global plugin constants
 */
var pluginConstantsGlobal = require('../shared/constants/PluginConstantsGlobal');

/**
 Definition of default settings for the plugins
*/
var defaultSettings = {
  loggingLevel: loggingLevels.NONE,
};

/**
 Collect all constants
*/
var pluginConstants = {
  loggingLevels: loggingLevels,
  messageTopics: messageTopics,
  messageDataTypes: messageDataTypes,
  pluginCapabilities: pluginConstantsGlobal.pluginCapabilities,
  pluginStatuses: pluginConstantsGlobal.pluginStatuses,
  setParameterResults: pluginConstantsGlobal.setParameterResults,
  requestExportResults: pluginConstantsGlobal.requestExportResults,
  defaultSettings: defaultSettings
};

/**
 * Global utilities
 */
var GlobalUtils = require('../shared/util/GlobalUtils');

/**
 Export a deep copy of the constants
*/
module.exports = GlobalUtils.deepCopy(pluginConstants);
